var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configuration-file-page ml-2"},[_c('pc-viewing-trace-doc')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }